<template>
  <div class="d-flex flex-column align-items-center bg-white px-4 px-md-5 py-5 w-100" style="max-width: 375px">
    <img src="https://wallkit.net/svg/sygnet.svg" alt="Logo" width="100" class="mb-3">
    <h3 class="font-weight-light">Restore password</h3>
    <b-form class="w-100">
      <b-input-group class="my-3">
        <label for="email" class="text-uppercase font-weight-light"><i class="fas fa-envelope-o mr-2"></i>Email</label>
        <b-input id="email" type="email" required class="w-100 rounded"></b-input>
      </b-input-group>
      <b-button class="w-100 btn-lg mb-3" @click="" variant="primary">Restore</b-button>
    </b-form>
    <div class="d-flex flex-row align-items-center align-self-end">
      <i class="fas fa-long-arrow-left fa-lg mr-2 text-primary"></i>
      <router-link :to="{path: '/popups/login'}" class="small text-uppercase">
        Back to login
      </router-link>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'passwordRecovery'
  }
</script>